import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-modal',
  templateUrl: './confirm-delete-modal.component.html',
  styleUrls: ['./confirm-delete-modal.component.css']
})
export class ConfirmDeleteModalComponent implements OnInit {

  constructor(
    private dialogRef : MatDialogRef<ConfirmDeleteModalComponent>
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  }


  confirmDelete(data){
    this.dialogRef.close(data.password);
  }

  closeModal(){
    this.dialogRef.close(null);
  }


}
